import {FETCH_PEOPLE_LEVEL_IN_CAMPAIGN, FETCH_PEOPLE_LEVEL_IN_CAMPAIGN_SUCCESS, FETCH_PEOPLE_LEVEL_IN_CAMPAIGN_ERROR, UPDATE_PEOPLE_LEVEL_IN_CAMPAIGN, UPDATE_PEOPLE_LEVEL_IN_CAMPAIGN_SUCCESS, UPDATE_PEOPLE_LEVEL_IN_CAMPAIGN_ERROR, RESET_UPDATE_PEOPLE_LEVEL_IN_CAMPAIGN} from "constants/ActionTypes";

export const fetchPeopleLevelInCampaign = () => {
  return {
    type: FETCH_PEOPLE_LEVEL_IN_CAMPAIGN,
  }
};

export const fetchPeopleLevelInCampaignSuccess = (rateCardList) => {
  return {
    type: FETCH_PEOPLE_LEVEL_IN_CAMPAIGN_SUCCESS,
    payload: rateCardList,
  }
};

export const fetchPeopleLevelInCampaignError = (error) => {
  return {
    type: FETCH_PEOPLE_LEVEL_IN_CAMPAIGN_ERROR,
    payload: error
  }
};

export const updatePeopleLevelInCampaign = (params) => {
  return {
    type: UPDATE_PEOPLE_LEVEL_IN_CAMPAIGN,
    params,
  }
};

export const updatePeopleLevelInCampaignSuccess = (payload) => {
  return {
    type: UPDATE_PEOPLE_LEVEL_IN_CAMPAIGN_SUCCESS,
    payload,
  }
};

export const updatePeopleLevelInCampaignError = (error) => {
  return {
    type: UPDATE_PEOPLE_LEVEL_IN_CAMPAIGN_ERROR,
    payload: error
  }
};

export const resetUpdatePeopleLevelInCampaign = () => {
  return {
    type: RESET_UPDATE_PEOPLE_LEVEL_IN_CAMPAIGN,
  }
};
